export const SEARCH_MOBILITY = "app/Search/SEARCH_MOBILITY";
export const SEARCH_MOBILITY_SUCCESS = "app/Search/SEARCH_MOBILITY_SUCCESS";
export const SEARCH_MOBILITY_FAILURE = "app/Search/SEARCH_MOBILITY_FAILURE";

export const SEARCH_REVIEW_SNAPSHOTS = "app/Search/SEARCH_REVIEW_SNAPSHOTS";
export const SEARCH_REVIEW_SNAPSHOTS_SUCCESS =
  "app/Search/SEARCH_REVIEW_SNAPSHOTS_SUCCESS";
export const SEARCH_REVIEW_SNAPSHOTS_FAILURE =
  "app/Search/SEARCH_REVIEW_SNAPSHOTS_FAILURE";

export const SEARCH_REVIEW_LOGS = "app/Search/SEARCH_REVIEW_LOGS";
export const SEARCH_REVIEW_LOGS_SUCCESS =
  "app/Search/SEARCH_REVIEW_LOGS_SUCCESS";
export const SEARCH_REVIEW_LOGS_FAILURE =
  "app/Search/SEARCH_REVIEW_LOGS_FAILURE";

export const SEARCH_CARE_PLAN = "app/Search/SEARCH_CARE_PLAN";
export const SEARCH_CARE_PLAN_SUCCESS = "app/Search/SEARCH_CARE_PLAN_SUCCESS";
export const SEARCH_CARE_PLAN_FAILURE = "app/Search/SEARCH_CARE_PLAN_FAILURE";

export const SEARCH_WARNING = "app/Search/SEARCH_WARNING";
export const SEARCH_WARNING_SUCCESS = "app/Search/SEARCH_WARNING_SUCCESS";
export const SEARCH_WARNING_FAILURE = "app/Search/SEARCH_WARNING_FAILURE";

// TO GET ALL LASTEST VERSION OF ALL PLANS
export const SEARCH_MAPPED_PLAN = "app/Search/SEARCH_MAPPED_PLAN";
export const SEARCH_MAPPED_PLAN_SUCCESS =
  "app/Search/SEARCH_MAPPED_PLAN_SUCCESS";
export const SEARCH_MAPPED_PLAN_FAILURE =
  "app/Search/SEARCH_MAPPED_PLAN_FAILURE";
